import { render, staticRenderFns } from "./base-tooltip.vue?vue&type=template&id=4283f0a4"
import script from "./base-tooltip.ts?vue&type=script&lang=ts&external"
export * from "./base-tooltip.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4283f0a4')) {
      api.createRecord('4283f0a4', component.options)
    } else {
      api.reload('4283f0a4', component.options)
    }
    module.hot.accept("./base-tooltip.vue?vue&type=template&id=4283f0a4", function () {
      api.rerender('4283f0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Tooltip/base-tooltip.vue"
export default component.exports